import BASEURLGESTTOR from '../api/gesttor'
import { novaCobrancaPayload } from '../../interfaces/cobrancas'

export function novaCobranca (idLancamento: number, payload: novaCobrancaPayload ) {
    return BASEURLGESTTOR.post(`/cobrancas/${idLancamento}`, payload)
}

export function visualizarCobranca (idCobranca: number) {
    return BASEURLGESTTOR.get(`/cobrancas/${idCobranca}`, {
        responseType: 'blob'
    })
}

export function gerarQrCode (idCobranca: number) {
    return BASEURLGESTTOR.get(`/cobrancas/qrcode/${idCobranca}`)
}

export function cancelarCobranca (idCobranca: number) {
    return BASEURLGESTTOR.put(`/cobrancas/${idCobranca}`)
}

export function enviarCobrancaWa (idCobranca: number) {
    return BASEURLGESTTOR.post(`/cobrancas/wa/${idCobranca}`)
}